import makeStyles from "e100-react-components/lib/styles/makeStyles";

const useStyles = makeStyles(({ spacing }) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 72px)",
    justifyContent: "space-between",
  },
}));

export default useStyles;
